<template>
  <div>
    彩票经理管理收益记录
    <div>彩票代表：用户名</div>
    <el-select v-model="jl_db.value" placeholder="">
          <el-option 
            v-for="(item,index) in jl_db.arr" :key="index"
            :label="item.label" :value="item.value"
          ></el-option>
        </el-select>
    <el-table >
      <el-table-column label="序号"></el-table-column>
      <el-table-column label="彩票代表上级主管"></el-table-column>
      <el-table-column label="篮球和后区最新准确率"></el-table-column>
      <el-table-column label="帮扶投注站和站号号"></el-table-column>
      <el-table-column label="最新帮扶众筹招股跳转链接"></el-table-column>
      <el-table-column label="实战篮球或者后区"></el-table-column>
      <el-table-column label="帮扶投注站站长以及联系方式"></el-table-column>
      <el-table-column label="1%的股权收益"></el-table-column>
      <el-table-column label="兑奖截图"></el-table-column>
      <el-table-column label="收益账户余额"></el-table-column>
      <el-table-column label="操作"></el-table-column>
    </el-table>

    <div>
      备注：
      <div>1、彩票代表双色球篮球10中7以上可以同时帮扶3个投注站，10中6可以同时帮扶2个投注站，10中5只能帮扶1个投注站。</div>
      <div>2、彩票代表大乐透后区10中9以上可以同时帮扶3个投注站，10中8可以同时帮扶2个投注站，10中7只能帮扶1个投注站。</div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      jl_db:{
        value:'彩票经理',
        arr:[
          {label:'彩票经理',value:1},
          {label:'彩票代表',value:2}
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>